import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import ScoreCompanyService from '../core/service'

export const getRiskScaleInterpretationThunk = createAsyncThunk(
  'score/corporateRiskScore/getRiskScaleInterpretationThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getRiskScaleInterpretation(
        params,
      )
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getHistoricalChangeDrdDataThunk = createAsyncThunk(
  'score/corporateRiskScore/getHistoricalChangeDrdDataThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getHistoricalChangeDrdData(
        params,
      )
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getHistoricalChangeThunk = createAsyncThunk(
  'score/corporateRiskScore/getHistoricalChangeThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getHistoricalChange(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const downloadHistoricalChange = createAsyncThunk(
  'score/corporateRiskScore/downloadHistoricalChange',
  async (params) => {
    try {
      const res = await ScoreCompanyService.downloadHistoricalChange(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const getPDTermStructureThunk = createAsyncThunk(
  'score/corporateRiskScore/getPDTermStructureThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getPDTermStructure(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getCommentaryThunk = createAsyncThunk(
  'score/corporateRiskScore/getCommentaryThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getCommentary(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getDistributionScoreThunk = createAsyncThunk(
  'score/corporateRiskScore/getDistributionScoreThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getDistributionScore(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const downloadDistributionScore = createAsyncThunk(
  'score/corporateRiskScore/downloadDistributionScore',
  async (params) => {
    try {
      const res = await ScoreCompanyService.downloadDistributionScore(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const getBreakdownThunk = createAsyncThunk(
  'score/corporateRiskScore/getBreakdownThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getBreakdown(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getBreakdownCompareThunk = createAsyncThunk(
  'score/corporateRiskScore/getBreakdownCompareThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getBreakdownCompare(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getRiskDriverDataThunk = createAsyncThunk(
  'score/corporateRiskScore/getRiskDriverDataThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getRiskDriverData(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const downloadRiskDriverData = createAsyncThunk(
  'score/corporateRiskScore/downloadRiskDriverData',
  async (params) => {
    try {
      const res = await ScoreCompanyService.downloadRiskDriverData(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

export const getRiskDriverCompareThunk = createAsyncThunk(
  'score/corporateRiskScore/getRiskDriverCompareThunk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScoreCompanyService.getRiskDriverCompare(params)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const downloadRiskDriverCompareData = createAsyncThunk(
  'score/corporateRiskScore/downloadRiskDriverCompareData',
  async (params) => {
    try {
      const res = await ScoreCompanyService.downloadRiskDriverCompareData(
        params,
      )
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
